import { render, staticRenderFns } from "./form-header.vue?vue&type=template&id=4654b734"
import script from "./form-header.vue?vue&type=script&lang=js"
export * from "./form-header.vue?vue&type=script&lang=js"
import style0 from "./form-header.vue?vue&type=style&index=0&id=4654b734&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports